/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { GenericTableColumn } from '@ui-components/Table/GenericTable';
import { GenericTag } from '@ui-components/Tag/GenericTag';
import GenericButton from '@ui-components/Button/GenericButton';
import { ReactComponent as IconConfig } from '../../../../../../shared/assets/Icons/IconSettings.svg';
export interface ClusterCloudPropagationNeighbor {
  bgpNeighborIp: string;
  peerAs: string;
  mode: 'Enterprise' | 'Telco';
  lastUpdate: string;
  bgpNeighborId?: number; // Optional BGP neighbor ID for cluster mode
  reflectorInstanceId?: number; // Add reflector instance ID for compatibility
}

// Interface for the API response structure (same as regular cloud propagation)
export interface CloudPropagationApiResponse {
  message: string;
  instanceId: string;
  instanceName: string;
  total: number;
  data: CloudPropagationRule[];
}

export interface CloudPropagationRule {
  id: number;
  bgpNeighborId: number;
  propagationType: string;
  mode: string;
  createdAt: string;
  updatedAt: string;
  bgpNeighbor: {
    id: number;
    neighborAddress: string;
    peerGroupId: string;
    interfaceAddressId: number;
    peerAs: number;
    localAs: number;
    description: string;
    operatingMode: string;
    propagationMode: string;
    holdTime: number;
    keepAliveInterval: number;
    connectRetry: number;
    gracefulRestart: boolean;
    addPath: boolean;
    BFD: boolean;
    bfdInterval: number;
    bfdRequiredMinRxInterval?: number | null;
    bfdMultiplier: number;
    password: string | null;
    status: string | null;
    reflectorInstanceId: number;
    createdAt: string;
    updatedAt: string;
    reflectorInstance: {
      id: number;
      name: string;
    };
  };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  inbound: any | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  outbound: any | null;
}



export const clusterCloudPropagationColumns: GenericTableColumn<ClusterCloudPropagationNeighbor>[] = [
  { header: 'BGP NEIGHBOR IP', accessor: 'bgpNeighborIp' },
  { header: 'PEER AS', accessor: 'peerAs' },
  {
    header: 'MODE',
    accessor: 'mode',
    renderCell: (row) => (
      <GenericTag
        label={row.mode}
        variant={row.mode === 'Enterprise' ? 'neutral' : 'warning'}
      />
    ),
  },
  { header: 'LAST UPDATED', accessor: 'lastUpdate' },
  {
    header: 'ACTIONS',
    accessor: undefined,
    renderCell: (row, rowIndex, onConfigure) => (
      <GenericButton
        isIconOnly
        icon={<IconConfig className="w-4 h-4 text-semantic-text-secondary" />}
        variant="secondary"
        shape="filled"
        size="sm"
        aria-label="Configure"
        onClick={() => onConfigure?.(rowIndex)}
      />
    ),
  },
];

export const mockClusterCloudPropagationNeighbors: ClusterCloudPropagationNeighbor[] = [
  {
    bgpNeighborIp: '172.16.0.2',
    peerAs: '65100',
    mode: 'Telco',
    lastUpdate: '6/1/2023, 10:00:00 AM',
    bgpNeighborId: 1,
    reflectorInstanceId: 1,
  },
  {
    bgpNeighborIp: '172.16.0.3',
    peerAs: '65101',
    mode: 'Telco',
    lastUpdate: '6/2/2023, 11:15:00 AM',
    bgpNeighborId: 2,
    reflectorInstanceId: 1,
  },
];
